var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 43,
    viewBox: "0 0 31 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7287 0.0351562C7.38187 0.0351562 0.609375 6.0932 0.609375 13.558C0.609375 25.5783 15.7287 42.1062 15.7287 42.1062C15.7287 42.1062 30.848 25.5783 30.848 13.558C30.848 6.0932 24.0755 0.0351562 15.7287 0.0351562ZM15.7287 21.0707C14.5325 21.0707 13.3633 20.7182 12.3687 20.0578C11.3742 19.3974 10.599 18.4587 10.1413 17.3605C9.68356 16.2623 9.5638 15.0539 9.79715 13.888C10.0305 12.7222 10.6065 11.6513 11.4523 10.8107C12.2981 9.97018 13.3757 9.39777 14.5488 9.16587C15.722 8.93396 16.9379 9.05299 18.043 9.50788C19.1481 9.96277 20.0926 10.7331 20.7572 11.7215C21.4217 12.7098 21.7764 13.8718 21.7764 15.0605C21.7746 16.654 21.1369 18.1817 20.0031 19.3084C18.8693 20.4352 17.3321 21.0689 15.7287 21.0707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8f3e438ca58f5be5efe34875d1c51dca.svg";
export { ForwardRef as ReactComponent };